export default {
  // "ei_section1": [
  //   {
  //     "name": "suffix",
  //     "label": "Suffix/Title",
  //     "label_lang":'title',
  //     "type": "textfield",
  //     "required": true,
  //     "placeholder": "Enter the suffix/title",
  //     "validator": "isString",
  //     "key": "pg2ei3",
  //     "useLabel": true,
  //     "gridRowProps": {},
  //     "gridColumnProps": {}
  //   },
  //   {
  //     "name": "prefix",
  //     "label": "Prefix *",
  //     "label_lang":'prefix',
  //     "type": "textfield",
  //     "required": true,
  //     "key": "pg2ei4",
  //     "placeholder": "Enter the prefix",
  //     "validator": "isString",
  //     "useLabel": true,
  //     "gridRowProps": {},
  //     "gridColumnProps": {}
  //   },
  //   {
  //     "name": "firstName",
  //     "label": "First name *",
  //     "label_lang":'first_name',
  //     "type": "textfield",
  //     "required": true,
  //     "placeholder": "Enter your first name",
  //     "validator": "isString",
  //     "key": "pg2ei6",
  //     "useLabel": true,
  //     "gridRowProps": {},
  //     "gridColumnProps": {}
  //   },
  //   {
  //     "name": "lastName",
  //     "label": "Last name *",
  //     "label_lang":'last_name',
  //     "type": "textfield",
  //     "required": true,
  //     "placeholder": "Enter your last name",
  //     "validator": "isString",
  //     "key": "pg2ei7",
  //     "useLabel": true,
  //     "gridRowProps": {},
  //     "gridColumnProps": {}
  //   },
  //   {
  //     "name": "mainContactType",
  //     "label": "Main contact type *",
  //     "label_lang":'main_contact_type',
  //     "type": "select",
  //     "required": true,
  //     "validator": "isValidList",
  //     "placeholder": "Select contact type",
  //     "key": "pg2ei5",
  //     "disabled": true,
  //     "useLabel": true,
  //     "gridRowProps": {},
  //     "gridColumnProps": {},
  //     "options": [
  //       {
  //         "label": "Lead Sales",
  //         "value": "Lead Sales"
  //       },
  //       {
  //         "label": "Lead Marketing",
  //         "value": "Lead Marketing"
  //       },
  //       {
  //         "label": "Lead Technical",
  //         "value": "Lead Technical"
  //       },
  //       {
  //         "label": "Sales Information",
  //         "value": "Sales Information"
  //       },
  //       {
  //         "label": "Marketing Information",
  //         "value": "Marketing Information"
  //       },
  //       {
  //         "label": "Technical Information",
  //         "value": "Technical Information"
  //       },
  //       {
  //         "label": "Security Information",
  //         "value": "Security Information"
  //       },
  //       {
  //         "label": "Events and Promotional Offers",
  //         "value": "Events and Promotional Offers"
  //       },
  //       {
  //         "label": "General Information",
  //         "value": "General Information"
  //       },
  //       {
  //         "label": "Standard User",
  //         "value": "Standard User"
  //       }
  //     ]
  //   }
  // ],

  //   "ei_section2": [
  //     {
  //       "name": "phone",
  //       "label": "Phone number *",
  //       "label_lang":'phone_number',
  //       "type": "textfield",
  //       "required": true,
  //       "validator": "isString",
  //       "placeholder": "Enter your phone number",
  //       "key": "pg2eci8",
  //       "useLabel": true,
  //       "gridRowProps": {},
  //       "gridColumnProps": {}
  //     },
  //     {
  //       "name": "email",
  //       "label": "Emain address *",
  //       "label_lang":'email_address',
  //       "type": "textfield",
  //       "required": true,
  //       "disabled": true,
  //       "validator": "isEmail",
  //       "placeholder": "Enter your company e-mail address",
  //       "key": "pg2eci9",
  //       "useLabel": true,
  //       "gridRowProps": {},
  //       "gridColumnProps": {}
  //     },
  //     {
  //       "name": "jobRole",
  //       "label": "Job role *",
  //       "label_lang":'job_role',
  //       "type": "select",
  //       "required": true,
  //       "validator": "isValidList",
  //       "placeholder": "Select the job role",
  //       "key": "pg1eap3",
  //       "useLabel": true,
  //       "gridRowProps": {},
  //       "gridColumnProps": {},
  //       "options": [
  //         {
  //           "label": "Accounting",
  //           "value": "Accounting"
  //         },
  //         {
  //           "label": "Administration",
  //           "value": "Administration"
  //         },
  //         {
  //           "label": "Development",
  //           "value": "Development"
  //         },
  //         {
  //           "label": "Executive",
  //           "value": "Executive"
  //         },
  //         {
  //           "label": "Finance",
  //           "value": "Finance"
  //         },
  //         {
  //           "label": "Helpdesk Support",
  //           "value": "Helpdesk Support"
  //         },
  //         {
  //           "label": "IT",
  //           "value": "IT"
  //         },
  //         {
  //           "label": "Marketing",
  //           "value": "Marketing"
  //         },
  //         {
  //           "label": "Owner",
  //           "value": "Owner"
  //         },
  //         {
  //           "label": "PR/Communications",
  //           "value": "PR/Communications"
  //         },
  //         {
  //           "label": "Professional Services",
  //           "value": "Professional Services"
  //         },
  //         {
  //           "label": "Sales Representative",
  //           "value": "Sales Representative"
  //         },
  //         {
  //           "label": "Sales Management",
  //           "value": "Sales Management"
  //         },
  //         {
  //           "label": "System/Pre-sales Engineer",
  //           "value": "System/Pre-sales Engineer"
  //         },
  //         {
  //           "label": "Technical Support",
  //           "value": "Technical Support"
  //         },
  //         {
  //           "label": "Training",
  //           "value": "Training"
  //         },
  //         {
  //           "label": "Web Administration/Master",
  //           "value": "Web Administration/Master"
  //         }
  //       ],
  //     },
  //     {
  //       "name": "AdditionalContactType",
  //       "label": "Additional contact type",
  //       "label_lang":'additional_contact_type',
  //       "type": "select",
  //       "required": true,
  //       "validator": "isValidList",
  //       "placeholder": "Select the contact type",
  //       "key": "pg1eap3",
  //       "useLabel": true,
  //       "gridRowProps": {},
  //       "gridColumnProps": {},
  //       "options": [
  //         {
  //           "label": "Lead Sales",
  //           "value": "Lead Sales"
  //         },
  //         {
  //           "label": "Lead Marketing",
  //           "value": "Lead Marketing"
  //         },
  //         {
  //           "label": "Lead Technical",
  //           "value": "Lead Technical"
  //         },
  //         {
  //           "label": "Sales Information",
  //           "value": "Sales Information"
  //         },
  //         {
  //           "label": "Marketing Information",
  //           "value": "Marketing Information"
  //         },
  //         {
  //           "label": "Technical Information",
  //           "value": "Technical Information"
  //         },
  //         {
  //           "label": "Security Information",
  //           "value": "Security Information"
  //         },
  //         {
  //           "label": "Events and Promotional Offers",
  //           "value": "Events and Promotional Offers"
  //         },
  //         {
  //           "label": "General Information",
  //           "value": "General Information"
  //         },
  //         {
  //           "label": "Standard User",
  //           "value": "Standard User"
  //         }
  //       ],
  //     },
  //     {
  //       "name": "primaryLanguage",
  //       "label": "Preferred Language *",
  //       "label_lang":"pref_language",
  //       "type": "select",
  //       "required": true,
  //       "validator": "isString",
  //       "placeholder": "Select a language",
  //       "key": "pg2eci12",
  //       "useLabel": true,
  //       "gridRowProps": {},
  //       "gridColumnProps": {},
  //       "options": [
  //         {
  //           "label": "Language 1",
  //           "value": "US_EN"
  //         },
  //         {
  //           "label": "Language 2",
  //           "value": "SP"
  //         },
  //         {
  //           "label": "Language 3",
  //           "value": "UD"
  //         }
  //       ]
  //     }
  //   ],

  eap_section1: [
    {
      name: "name",
      type: "textfield",
      maxLength: 255,
      label: "Full company name",
      label_lang: "ConsolePartnerAccountCompName",
      key: "pg1sec3_1",
      validator: "isString",
      placeholder: "Enter the Company name",
      required: true,
      disabled: true,
      useLabel: true,
      gridRowProps: {},
      gridColumnProps: {},
    },
    {
      name: "tradingName",
      label: "Trading name",
      type: "textfield",
      maxLength: 80,
      label_lang: "ConsolePartnerAccountTradingName",
      placeholder: "Enter your trading name",
      validator: "isString",
      key: "pg1eap1",
      useLabel: true,
      gridRowProps: {},
      gridColumnProps: {},
    },

    {
      name: "companyType",
      label: "Company Type(select all that apply)*",
      type: "select",
      required: true,
      multiple: true,
      validator: "isValidList",
      placeholder: "Select company type(s)",
      key: "pg3_6",
      label_lang: "ConsolePartnerAccountCType",
      useLabel: true,
      gridRowProps: {},
      gridColumnProps: {},
      options: [
        {
          label: "Large Account Reseller (LAR)",
          value: "Large Account Reseller (LAR)",
        },
        {
          label: "Value Added Reseller (VAR)",
          value: "Value Added Reseller (VAR)",
        },
        {
          label: "Systems Integrator (SI)",
          value: "Systems Integrator (SI)",
        },
        {
          label: "Independent Software Vendor (ISV)",
          value: "Independent Software Vendor (ISV)",
        },
        {
          label: "Original Equipment Manufacturer (OEM)",
          value: "Original Equipment Manufacturer (OEM)",
        },
        {
          label: "Consulting Firm",
          value: "Consulting Firm",
        },
        {
          label: "Service(s) Provider",
          value: "Service(s) Provider",
        },
        {
          label: "Authorized Distributor",
          value: "Authorized Distributor",
        },
        {
          label: "Online Retailer",
          value: "Online Retailer",
        },
        {
          label: "Retail Partner",
          value: "Retail Partner",
        },
      ],
    },

    {
      name: "billingStreet",
      label: "Street *",
      label_lang: "ConsolePartnerAccountStreet",
      type: "textfield",
      maxLength: 255,
      required: true,
      placeholder: "Enter your street",
      validator: "isString",
      key: "pg1eap4",
      useLabel: true,
      gridRowProps: {},
      gridColumnProps: {},
    },
    {
      name: "billingCity",
      label: "City *",
      label_lang: "ConsolePartnerAccountCity",
      type: "textfield",
      maxLength: 40,
      required: true,
      placeholder: "Enter your city",
      validator: "isString",
      key: "pg1eap5",
      useLabel: true,
      gridRowProps: {},
      gridColumnProps: {},
    },
    {
      name: "billingState",
      label: "State/Province *",
      label_lang: "ConsolePartnerAccountState",
      type: "textfield",
      maxLength: 20,
      required: true,
      validator: "isString",
      placeholder: "State/Province",
      key: "pg1eap6",
      useLabel: true,
      gridRowProps: {},
      gridColumnProps: {},
      actions: [
        {
          fieldName: "billingCountry",
          func: "setStateType",
        },
      ],
    },
    {
      name: "billingCountry",
      type: "textfield",
      label: "Country/Region *",
      label_lang: "ConsolePartnerAccountCountry",
      key: "pg1sec3_7",
      required: true,
      disabled: true,
      validator: "isString",
      placeholder: "Country/Region",
      useLabel: true,
      gridRowProps: {},
      gridColumnProps: {},
    },
    {
      name: "billingPostalCode",
      label: "Postal Code *",
      label_lang: "ConsolePartnerAccountPostal",
      type: "textfield",
      maxLength: 20,
      required: true,
      validator: "isString",
      placeholder: "Postal Code",
      key: "pg1eap7",
      useLabel: true,
      gridRowProps: {},
      gridColumnProps: {},
    },

    {
      name: "appearInPartnerFinder",
      label: "List in Partner Finder?",
      label_lang: "ConsolePartnerAccountListPartnerFinder",
      type: "checkbox",
      useLabel: true,
      renderLabel: false,
      fieldLableProps: { position: "left" },
      displayLabel: { true: "Yes", false: "No" },
      key: "pg1eap8",
      gridRowProps: {},
      gridColumnProps: {},
    },
  ],
  eap_section2: [
    {
      name: "preferredDistributor",
      label: "Preferred distributor",
      label_lang: "OnbrdProfilePreferredDistributor",
      type: "textfield",
      maxLength: 255,
      placeholder: "Enter your preferred distributor",
      key: "pg1eap2",
      useLabel: true,
      gridRowProps: {},
      gridColumnProps: {},
    },

    {
      name: "bizRegistrationNum",
      label: "Business registration number",
      type: "textfield",
      maxLength: 80,
      label_lang: "ConsolePartnerAccountBRN",
      validator: "isString",
      placeholder: "Enter your business registration number",
      key: "pg1eap9",
      useLabel: true,
      gridRowProps: {},
      gridColumnProps: {},
    },

    {
      name: "dateFounded",
      label: "Year Established *",
      label_lang: "ConsolePartnerAccountYOI",
      type: "textfield",
      maxLength: 4,
      required: true,
      validator: "isYear",
      placeholder: "Enter your year established",
      key: "pg1eap10",
      useLabel: true,
      gridRowProps: {},
      gridColumnProps: {},
    },
    {
      name: "companyPhone",
      label: "Primary Phone *",
      label_lang: "ConsolePartnerAccountPhone",
      type: "textfield",
      required: true,
      validator: "isValidPhoneNumber",
      placeholder: "Enter the primary phone number",
      key: "pg1eap11",
      useLabel: true,
      gridRowProps: {},
      gridColumnProps: {},
    },
    {
      name: "fax",
      label: "Primary fax",
      label_lang: "ConsolePartnerAccountFax",
      type: "textfield",
      placeholder: "Enter the fax machine number",
      key: "pg1eap12",
      useLabel: true,
      gridRowProps: {},
      gridColumnProps: {},
    },
    {
      name: "companyEmail",
      label: "Emain address *",
      label_lang: "ConsolePartnerAccountEmailAdd",
      type: "textfield",
      required: true,
      disabled: true,
      validator: "isEmail",
      placeholder: "Enter your company e-mail address",
      key: "pg1eap13",
      useLabel: true,
      gridRowProps: {},
      gridColumnProps: {},
    },
    {
      name: "primaryUrl",
      label: "Website *",
      label_lang: "ConsolePartnerAccountWeb",
      type: "textfield",
      maxLength: 255,
      required: true,
      validator: "isValidWebsite",
      placeholder: "Enter your company website URL",
      key: "pg1eap14",
      useLabel: true,
      gridRowProps: {},
      gridColumnProps: {},
    },
    {
      name: "secondaryUrl",
      label: "Secondary website",
      label_lang: "ConsolePartnerAccountWeb2",
      type: "textfield",
      maxLength: 255,
      validator: "isValidWebsite",
      placeholder: "Enter a secondary website URL",
      key: "pg1eap15",
      useLabel: true,
      gridRowProps: {},
      gridColumnProps: {},
    },
  ],
  //   "ac_section1": [
  //     {
  //       "name": "prefix",
  //       "label": "Prefix",
  //       "label_lang":"prefix",
  //       "type": "textfield",
  //       "required": true,
  //       "placeholder": "Enter the prefix",
  //       "validator": "isString",
  //       "key": "pg1ac1",
  //       "useLabel": true,
  //       "gridRowProps": {},
  //       "gridColumnProps": {}
  //     },
  //     {
  //       "name": "suffix",
  //       "label": "Suffix/Title",
  //       "label_lang":"title",
  //       "type": "textfield",
  //       "required": true,
  //       "placeholder": "Enter the suffix/title",
  //       "validator": "isString",
  //       "key": "pg1ac2",
  //       "useLabel": true,
  //       "gridRowProps": {},
  //       "gridColumnProps": {}
  //     },
  //     {
  //       "name": "firstName",
  //       "label": "First name",
  //       "label_lang":"first_name",
  //       "type": "textfield",
  //       "required": true,
  //       "placeholder": "Enter your first name",
  //       "validator": "isString",
  //       "key": "pg1ac3",
  //       "useLabel": true,
  //       "gridRowProps": {},
  //       "gridColumnProps": {}
  //     },
  //     {
  //       "name": "lastName",
  //       "label": "Last name",
  //       "label_lang":"last_name",
  //       "type": "textfield",
  //       "required": true,
  //       "placeholder": "Enter your trading name",
  //       "validator": "isString",
  //       "key": "pg1ac4",
  //       "useLabel": true,
  //       "gridRowProps": {},
  //       "gridColumnProps": {}
  //     },
  //     {
  //       "name": "mainContactType",
  //       "label": "Main contact type",
  //       "label_lang":"main_contact_type",
  //       "type": "select",
  //       "required": true,
  //       "disabled": false,
  //       "validator": "isValidList",
  //       "placeholder": "Select contact type",
  //       "key": "pg1ac5",
  //       "useLabel": true,
  //       "gridRowProps": {},
  //       "gridColumnProps": {},
  //       "options": [
  //         {
  //           "label": "Lead Sales",
  //           "value": "Lead Sales"
  //         },
  //         {
  //           "label": "Lead Marketing",
  //           "value": "Lead Marketing"
  //         },
  //         {
  //           "label": "Lead Technical",
  //           "value": "Lead Technical"
  //         },
  //         {
  //           "label": "Sales Information",
  //           "value": "Sales Information"
  //         },
  //         {
  //           "label": "Marketing Information",
  //           "value": "Marketing Information"
  //         },
  //         {
  //           "label": "Technical Information",
  //           "value": "Technical Information"
  //         },
  //         {
  //           "label": "Security Information",
  //           "value": "Security Information"
  //         },
  //         {
  //           "label": "Events and Promotional Offers",
  //           "value": "Events and Promotional Offers"
  //         },
  //         {
  //           "label": "General Information",
  //           "value": "General Information"
  //         },
  //         {
  //           "label": "Standard User",
  //           "value": "Standard User"
  //         }
  //       ],
  //     }
  //   ],
  //   "ac_section2": [
  //     {
  //       "name": "phone",
  //       "label": "Phone *",
  //       "label_lang":"phone",
  //       "type": "textfield",
  //       "required": true,
  //       "validator": "isString",
  //       "placeholder": "Enter the primary phone number",
  //       "key": "pg1ac6",
  //       "useLabel": true,
  //       "gridRowProps": {},
  //       "gridColumnProps": {}
  //     },
  //     {
  //       "name": "email",
  //       "label": "Email",
  //       "label_lang":"email",
  //       "type": "textfield",
  //       "required": true,
  //       "disabled": false,
  //       "validator": "isEmail",
  //       "placeholder": "Enter your company e-mail address",
  //       "key": "pg1ac7",
  //       "useLabel": true,
  //       "gridRowProps": {},
  //       "gridColumnProps": {}
  //     },
  //     {
  //       "name": "jobRole",
  //       "label": "Job role",
  //       "label_lang":"job_role",
  //       "type": "select",
  //       "required": true,
  //       "validator": "isString",
  //       "placeholder": "Select a job role",
  //       "key": "pg1ac8",
  //       "useLabel": true,
  //       "gridRowProps": {},
  //       "gridColumnProps": {},
  //      "options": [
  //         {
  //           "label": "Accounting",
  //           "value": "Accounting"
  //         },
  //         {
  //           "label": "Administration",
  //           "value": "Administration"
  //         },
  //         {
  //           "label": "Development",
  //           "value": "Development"
  //         },
  //         {
  //           "label": "Executive",
  //           "value": "Executive"
  //         },
  //         {
  //           "label": "Finance",
  //           "value": "Finance"
  //         },
  //         {
  //           "label": "Helpdesk Support",
  //           "value": "Helpdesk Support"
  //         },
  //         {
  //           "label": "IT",
  //           "value": "IT"
  //         },
  //         {
  //           "label": "Marketing",
  //           "value": "Marketing"
  //         },
  //         {
  //           "label": "Owner",
  //           "value": "Owner"
  //         },
  //         {
  //           "label": "PR/Communications",
  //           "value": "PR/Communications"
  //         },
  //         {
  //           "label": "Professional Services",
  //           "value": "Professional Services"
  //         },
  //         {
  //           "label": "Sales Representative",
  //           "value": "Sales Representative"
  //         },
  //         {
  //           "label": "Sales Management",
  //           "value": "Sales Management"
  //         },
  //         {
  //           "label": "System/Pre-sales Engineer",
  //           "value": "System/Pre-sales Engineer"
  //         },
  //         {
  //           "label": "Technical Support",
  //           "value": "Technical Support"
  //         },
  //         {
  //           "label": "Training",
  //           "value": "Training"
  //         },
  //         {
  //           "label": "Web Administration/Master",
  //           "value": "Web Administration/Master"
  //         }
  //       ],

  //     },
  //     {
  //       "name": "primaryLanguage",
  //       "label": "Preferred Language",
  //       "label_lang":"pref_language",
  //       "type": "select",
  //       "required": true,
  //       "validator": "isString",
  //       "placeholder": "Select a language",
  //       "key": "pg1ac9",
  //       "useLabel": true,
  //       "gridRowProps": {},
  //       "gridColumnProps": {},
  //       "options": [
  //         {
  //           "label": "Language 1",
  //           "value": "US_EN"
  //         },
  //         {
  //           "label": "Language 2",
  //           "value": "SP"
  //         },
  //         {
  //           "label": "Language 3",
  //           "value": "UD"
  //         }
  //       ]
  //     },
  //     {
  //       "name": "type",
  //       "label": "Type",
  //       "label_lang":"type",
  //       "type": "select",
  //       "required": true,
  //       "validator": "isString",
  //       "placeholder": "Select a type",
  //       "key": "pg1ac10",
  //       "useLabel": true,
  //       "gridRowProps": {},
  //       "gridColumnProps": {},
  //       "options": [
  //         {
  //           "label": "type 1",
  //           "value": "type 1"
  //         },
  //         {
  //           "label": "type 2",
  //           "value": "type 2"
  //         },
  //         {
  //           "label": "type 3",
  //           "value": "type 3"
  //         }
  //       ]
  //     }
  //   ],

  page1_section1: [
    {
      name: "membershipId",
      type: "textField",
      label: "Membership ID",
      label_lang: "ConsolePartnerMembershipId",
      key: "pg1sec1_1",
      required: false,
      gridRowProps: {},
      gridColumnProps: {},
    },
    {
      name: "parentMembershipId",
      type: "textField",
      label: "Parent membership ID",
      label_lang: "ConsolePartnerParentMemId",
      key: "pg1sec1_2",
      required: false,
      gridRowProps: {},
      gridColumnProps: {},
    },
    {
      name: "level",
      type: "textField",
      label: "Partner Level",
      label_lang: "ConsolePartnerAccountLevel",
      key: "pg1sec1_3",
      required: false,

      gridRowProps: {},
      gridColumnProps: {},
    },
    {
      name: "additionalLicenses",
      type: "textField",
      label: "Number of additional licenses",
      label_lang: "ConsolePartnerAccountLicReq",
      key: "pg1sec1_4",
      required: false,

      gridRowProps: {},
      gridColumnProps: {},
    },
  ],
  page1_section2: [
    {
      name: "specialisation",
      type: "textField",
      label: "Specialization",
      label_lang: "ConsolePartnerAccountSpec",
      key: "pg1sec2_1",
      required: false,

      gridRowProps: {},
      gridColumnProps: {},
    },
    {
      name: "anniversaryDate",
      type: "textField",
      label: "Contract start date",
      label_lang: "ConsolePartnerAccountStartDate",
      key: "pg1sec2_2",
      required: false,
      gridRowProps: {},
      gridColumnProps: {},
    },
    {
      name: "contractEndDate",
      type: "textField",
      label: "Contract end date",
      label_lang: "ConsolePartnerAccountEndDate",
      key: "pg1sec2_3",
      required: false,
      gridRowProps: {},
      gridColumnProps: {},
    },
  ],
  page2_section1: [
    {
      name: "name",
      type: "textField",
      label: "Full company name",
      label_lang: "ConsolePartnerAccountCompName",
      key: "pg2sec1_1",
      required: false,

      gridRowProps: {},
      gridColumnProps: {},
    },
  ],
  page2_section2: [
    {
      name: "active",
      type: "textField",
      label: "Active",
      label_lang: "ConsolePartnerConActive",
      key: "pg2sec1_2",
      required: false,

      gridRowProps: {},
      gridColumnProps: {},
    },
  ],
  section13: [
    {
      name: "prefix",
      label: "Prefix",
      label_lang: "ConsolePartnerConPrefix",
      type: "textfield",
      maxLength: 10,
      placeholder: "Enter the prefix",
      validator: "prefixContactField",
      key: "pg1ac1",
      useLabel: true,
      gridRowProps: {},
      gridColumnProps: {},
    },
    {
      name: "suffix",
      label: "Suffix/Title",
      label_lang: "ConsolePartnerConSuffix",
      type: "textfield",
      maxLength: 10,
      placeholder: "Enter the suffix/title",
      validator: "suffixContactField",
      key: "pg1ac2",
      useLabel: true,
      gridRowProps: {},
      gridColumnProps: {},
    },
    {
      name: "firstName",
      label: "First Name *",
      label_lang: "OnbrdContactFName",
      type: "textfield",
      maxLength: 40,
      required: true,
      validator: "isString",
      placeholder: "First name",
      key: "pg4_15",
      useLabel: true,
      gridRowProps: {},
      gridColumnProps: {},
    },
    {
      name: "lastName",
      label: "Last Name *",
      label_lang: "OnbrdContactLName",
      type: "textfield",
      maxLength: 80,
      required: true,
      validator: "isString",
      placeholder: "Last name",
      key: "pg4_19",
      useLabel: true,
      gridRowProps: {},
      gridColumnProps: {},
    },
    {
      name: "mainContactType",
      type: "textfield",
      label: "Main contact type",
      label_lang: "ConsolePartnerConMainType",
      placeholder: "Other",
      useLabel: true,
      key: "pg2sec1_5",
      disabled: true,
      gridRowProps: {},
      gridColumnProps: {},
    },
    {
      name: "active",
      type: "checkbox",
      label: "Active",
      label_lang: "ConsolePartnerConActive",
      useLabel: true,
      hide: true,
      renderLabel: false,
      fieldLableProps: { position: "left" },
      key: "pg2sec1_5",
      gridRowProps: {},
      gridColumnProps: {},
    },
  ],
  section14: [
    {
      name: "phone",
      label: "Phone Number *",
      label_lang: "ConsolePartnerConPhone",
      type: "textfield",
      required: true,
      validator: "isValidPhoneNumber",
      placeholder: "Enter your phone number",
      key: "pg4_20",
      useLabel: true,
      gridRowProps: {},
      gridColumnProps: {},
    },
    {
      name: "email",
      label: "E-mail Address *",
      label_lang: "ConsolePartnerConEmail",
      type: "textfield",
      required: true,
      validator: "isEmailDomain",
      placeholder: "E-mail address",
      key: "pg4_16",
      useLabel: true,
      gridRowProps: {},
      gridColumnProps: {},
    },
    {
      name: "jobRole",
      label: "Job Role *",
      label_lang: "ConsolePartnerConRole",
      type: "select",
      required: true,
      validator: "isString",
      placeholder: "Select a job role",
      options: [
        {
          label: "Accounting",
          value: "Accounting",
        },
        {
          label: "Administration",
          value: "Administration",
        },
        {
          label: "Development",
          value: "Development",
        },
        {
          label: "Executive",
          value: "Executive",
        },
        {
          label: "Finance",
          value: "Finance",
        },
        {
          label: "Helpdesk Support",
          value: "Helpdesk Support",
        },
        {
          label: "IT",
          value: "IT",
        },
        {
          label: "Marketing",
          value: "Marketing",
        },
        {
          label: "Owner",
          value: "Owner",
        },
        {
          label: "Partner Specialist",
          value: "Partner Specialist",
        },
        {
          label: "PR/Communications",
          value: "PR/Communications",
        },
        {
          label: "Professional Services",
          value: "Professional Services",
        },
        {
          label: "Sales Representative",
          value: "Sales Representative",
        },
        {
          label: "Sales Management",
          value: "Sales Management",
        },
        {
          label: "System/Pre-sales Engineer",
          value: "System/Pre-sales Engineer",
        },
        {
          label: "Technical Support",
          value: "Technical Support",
        },
        {
          label: "Training",
          value: "Training",
        },
        {
          label: "Web Administration/Master",
          value: "Web Administration/Master",
        },
      ],
      key: "pg4_17",
      useLabel: true,
      gridRowProps: {},
      gridColumnProps: {},
    },
    {
      name: "preferredLanguage",
      label: "Primary Language *",
      label_lang: "ConsolePartnerConLang",
      type: "select",
      required: true,
      validator: "isString",
      placeholder: "Select a language",
      options: [],
      key: "pg4_18",
      useLabel: true,
      gridRowProps: {},
      gridColumnProps: {},
      actions: [
        {
          fieldName: "billingCountry",
          func: "languageAction",
        },
        {
          fieldName: "billingCountry",
          func: "setLanguageMP",
        },
      ],
    },
    {
      name: "additionalContactType",
      label: "Contact Type(select all that apply) *",
      label_lang: "ConsolePartnerContactAddRole",
      type: "select",
      required: true,
      validator: "isValidList",
      placeholder: "Select contact type(s)",
      options: [
        {
          label: "Lead Sales",
          value: "Lead Sales",
        },
        {
          label: "Lead Marketing",
          value: "Lead Marketing",
        },
        {
          label: "Lead Technical",
          value: "Lead Technical",
        },
        {
          label: "Sales Information",
          value: "Sales Information",
        },
        {
          label: "Marketing Information",
          value: "Marketing Information",
        },
        {
          label: "Technical Information",
          value: "Technical Information",
        },
        {
          label: "Security Information",
          value: "Security Information",
        },
        {
          label: "Events and Promotional Offers",
          value: "Events and Promotional Offers",
        },
        {
          label: "General Information",
          value: "General Information",
        },
        {
          label: "Standard User",
          value: "Standard User",
        },
      ],
      multiple: true,
      key: "pg4_22",
      useLabel: true,
      gridRowProps: {},
      gridColumnProps: {},
    },
  ],

  section15: [
    {
      name: "prefix",
      label: "Prefix",
      label_lang: "ConsolePartnerConPrefix",
      type: "textfield",
      maxLength: 10,
      placeholder: "Enter the prefix",
      validator: "prefixContactField",
      key: "pg1ac1",
      useLabel: true,
      gridRowProps: {},
      gridColumnProps: {},
    },
    {
      name: "suffix",
      label: "Suffix/Title",
      label_lang: "ConsolePartnerConSuffix",
      type: "textfield",
      maxLength: 10,
      placeholder: "Enter the suffix/title",
      validator: "suffixContactField",
      key: "pg1ac2",
      useLabel: true,
      gridRowProps: {},
      gridColumnProps: {},
    },
    {
      name: "firstName",
      label: "First Name *",
      label_lang: "OnbrdContactFName",
      type: "textfield",
      maxLength: 40,
      required: true,
      validator: "isString",
      placeholder: "First name",
      key: "pg4_15",
      useLabel: true,
      gridRowProps: {},
      gridColumnProps: {},
    },
    {
      name: "lastName",
      label: "Last Name *",
      label_lang: "OnbrdContactLName",
      type: "textfield",
      maxLength: 80,
      required: true,
      validator: "isString",
      placeholder: "Last name",
      key: "pg4_19",
      useLabel: true,
      gridRowProps: {},
      gridColumnProps: {},
    },
    {
      name: "mainContactType",
      type: "textfield",
      label: "Main contact type",
      label_lang: "ConsolePartnerConMainType",
      placeholder: "Other",
      useLabel: true,
      key: "pg2sec1_5",
      disabled: true,
      gridRowProps: {},
      gridColumnProps: {},
    },
    {
      name: "active",
      type: "checkbox",
      label: "Active",
      label_lang: "ConsolePartnerConActive",
      useLabel: true,
      hide: true,
      renderLabel: false,
      fieldLableProps: { position: "left" },
      key: "pg2sec1_5",
      gridRowProps: {},
      gridColumnProps: {},
    },
  ],
  section16: [
    {
      name: "phone",
      label: "Phone Number *",
      label_lang: "ConsolePartnerConPhone",
      type: "textfield",
      required: true,
      validator: "isValidPhoneNumber",
      placeholder: "Enter your phone number",
      key: "pg4_20",
      useLabel: true,
      gridRowProps: {},
      gridColumnProps: {},
    },
    {
      name: "email",
      label: "E-mail Address *",
      label_lang: "ConsolePartnerConEmail",
      type: "textfield",
      required: true,
      disabled: true,
      validator: "isEmailDomain",
      placeholder: "E-mail address",
      key: "pg4_16",
      useLabel: true,
      gridRowProps: {},
      gridColumnProps: {},
    },
    {
      name: "jobRole",
      label: "Job Role *",
      label_lang: "ConsolePartnerConRole",
      type: "select",
      required: true,
      validator: "isString",
      placeholder: "Select a job role",
      options: [
        {
          label: "Accounting",
          value: "Accounting",
        },
        {
          label: "Administration",
          value: "Administration",
        },
        {
          label: "Development",
          value: "Development",
        },
        {
          label: "Executive",
          value: "Executive",
        },
        {
          label: "Finance",
          value: "Finance",
        },
        {
          label: "Helpdesk Support",
          value: "Helpdesk Support",
        },
        {
          label: "IT",
          value: "IT",
        },
        {
          label: "Marketing",
          value: "Marketing",
        },
        {
          label: "Owner",
          value: "Owner",
        },
        {
          label: "Partner Specialist",
          value: "Partner Specialist",
        },
        {
          label: "PR/Communications",
          value: "PR/Communications",
        },
        {
          label: "Professional Services",
          value: "Professional Services",
        },
        {
          label: "Sales Representative",
          value: "Sales Representative",
        },
        {
          label: "Sales Management",
          value: "Sales Management",
        },
        {
          label: "System/Pre-sales Engineer",
          value: "System/Pre-sales Engineer",
        },
        {
          label: "Technical Support",
          value: "Technical Support",
        },
        {
          label: "Training",
          value: "Training",
        },
        {
          label: "Web Administration/Master",
          value: "Web Administration/Master",
        },
      ],
      key: "pg4_17",
      useLabel: true,
      gridRowProps: {},
      gridColumnProps: {},
    },
    {
      name: "preferredLanguage",
      label: "Primary Language *",
      label_lang: "ConsolePartnerConLang",
      type: "select",
      required: true,
      validator: "isString",
      placeholder: "Select a language",
      options: [],
      key: "pg4_18",
      useLabel: true,
      gridRowProps: {},
      gridColumnProps: {},
      actions: [
        {
          fieldName: "billingCountry",
          func: "languageAction",
        },
        {
          fieldName: "billingCountry",
          func: "setLanguageMPOther",
        },
      ],
    },
    {
      name: "additionalContactType",
      label: "Contact Type(select all that apply) *",
      label_lang: "ConsolePartnerContactAddRole",
      type: "select",
      required: true,
      validator: "isValidList",
      placeholder: "Select contact type(s)",
      options: [
        {
          label: "Lead Sales",
          value: "Lead Sales",
        },
        {
          label: "Lead Marketing",
          value: "Lead Marketing",
        },
        {
          label: "Lead Technical",
          value: "Lead Technical",
        },
        {
          label: "Sales Information",
          value: "Sales Information",
        },
        {
          label: "Marketing Information",
          value: "Marketing Information",
        },
        {
          label: "Technical Information",
          value: "Technical Information",
        },
        {
          label: "Security Information",
          value: "Security Information",
        },
        {
          label: "Events and Promotional Offers",
          value: "Events and Promotional Offers",
        },
        {
          label: "General Information",
          value: "General Information",
        },
        {
          label: "Standard User",
          value: "Standard User",
        },
      ],
      multiple: true,
      key: "pg4_22",
      useLabel: true,
      gridRowProps: {},
      gridColumnProps: {},
    },
  ],
};
